/* @flow */

import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import glamorous from 'glamorous';
import Page from 'app/containers/parts/Page';
import Spinner from 'app/components/commons/Spinner';
import Title from 'app/components/commons/Title';
import NestedContentSection from './NestedContentSection';

type Item = {
  id: string,
  content: string,
  title: string
};

type Datum = {
  id: number,
  items: Array<Item>,
  name: string
};

type Props = {
  data?: Array<Datum>,
  isLoading?: boolean,
  onMount: Function,
  title: string,
  link?: string
};

type State = {
  activeKey: mixed
};

const NestedContentDiv = glamorous.div(props => ({
  paddingLeft: props.theme.spacing.small,
  paddingRight: props.theme.spacing.small
}));

class NestedContent extends PureComponent<Props, State> {
  props: Props;

  state: State = {
    activeKey: null
  };

  static defaultProps = {
    data: [],
    isLoading: false,
    link: undefined
  };

  componentDidMount() {
    const { onMount, link } = this.props;

    if (onMount) {
      onMount(link);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { link, onMount } = this.props;
    if (nextProps.link !== link) {
      onMount(nextProps.link);
    }
  }

  handleChange = (activeKey: mixed) => this.setState({ activeKey });

  render() {
    const { data, isLoading, title, link } = this.props;
    const { activeKey } = this.state;

    return (
      <Page>
        <div>
          <Helmet title={title} />
          <Title noWhiteSpace>{title}</Title>
          <hr />
          {isLoading ? (
            <Spinner center />
          ) : (
            <NestedContentDiv key={link}>
              {data.map((
                datum // $FlowFixMe
              ) => (
                <NestedContentSection
                  key={datum.id}
                  activeKey={activeKey}
                  items={datum.items}
                  name={datum.name}
                  onChange={this.handleChange}
                />
              ))}
            </NestedContentDiv>
          )}
        </div>
      </Page>
    );
  }
}

export default NestedContent;
